import { Avatar } from '@mui/material';
import { ReactNode } from 'react';

// Rounded square with a light primary tint, used as the leading icon in list rows.
export function TintedIcon({ children }: { children: ReactNode }) {
  return (
    <Avatar
      variant="rounded"
      sx={{
        width: 36,
        height: 36,
        borderRadius: 1.5,
        bgcolor: (theme) => theme.lighten(theme.palette.primary.main, 0.85),
        color: 'primary.dark',
      }}>
      {children}
    </Avatar>
  );
}
